import { useOrganizationMCPServers } from '@/hooks/mcp/useOrganizationMCPServers'

import type { UUID } from '@/types/Id'
import type { OrganizationMCPServer } from '@/types/MCPServer'

interface UseHasSharepointIntegrationArgs {
  orgId: UUID | ''
}

const selectHasSharepointIntegration = (data: OrganizationMCPServer[]) => {
  return data.some(
    (s) =>
      s.mcp_server.server_name === 'microsoft' &&
      s.is_active === true &&
      s.user_has_token === true &&
      s.needs_reauth !== true,
  )
}

/**
 * Check if the current user has an active MCP token for the Microsoft server.
 * Replaces the old Nango-based integration check.
 */
export const useHasSharepointIntegration = ({
  orgId,
}: UseHasSharepointIntegrationArgs) => {
  return useOrganizationMCPServers({
    orgId,
    select: selectHasSharepointIntegration,
  })
}
